import React from 'react'
import Rest from 'tools/rest';
import { Select } from 'antd';
import Preloader from 'components/preloader';

class UserSelect extends React.Component {

    state = {
        users: [],
        loading: false,
    }

    loadUsers = () => {
        this.setState({ loading: true })
        Rest.get(`/api/v1/users/${this.props.scope}`).then((response) => {
            this.setState({
                loading: false,
                users: response.data.users,
            });
        });
    };

    componentDidMount() {
        this.loadUsers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.scope !== this.props.scope) {
            this.loadUsers();
        }
    }

    render() {
        const { loading, users } = this.state
        const options = users.map((user) => ({
            value: user.id,
            label: user.name,
        }))
        return <Preloader loading={loading}>
            <Select
                value={this.props.value}
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                style={this.props.style}
                allowClear
                showSearch
                optionFilterProp="children"
            >
                {users.map((user) => (
                    <Option key={user.id} value={user.id}>{user.name}</Option>
                ))}
            </Select>
        </Preloader>
    }
}
export default UserSelect